import TableWrap from './tableWrap'
import DlgWrap from './dlgWrap'
import EvalItem from './evalItem'
import TemplateValueOption from './templateValueOption'
import EvalModelValueOption from './evalModelValueOption'
import QueryPriceOption from './queryPriceOption'
import CommissionItem from './commissionItem'
import ProfitItem from './profitItem'
import OrderItemDetail from './orderItemDetail'
import ItemDetail from './itemDetail'
import orderItemTag from './orderItemTag'
import orderConditionTag from './orderConditionTag'
import orderFunctionTag from './orderFunctionTag'
import orderTag from './orderTag'
import VoucherItem from './voucherItem.vue'
import AprItem from './aprItem.vue'
import PriceRuleItem from './priceRuleItem.vue'

export default (Vue) => {
  // 注册全局组建实例
  Vue.component('TableWrap',TableWrap);
  Vue.component('DlgWrap',DlgWrap);
  Vue.component('EvalItem',EvalItem);
  Vue.component('CommissionItem',CommissionItem);
  Vue.component('ProfitItem',ProfitItem);
  Vue.component('TemplateValueOption',TemplateValueOption);
  Vue.component('EvalModelValueOption',EvalModelValueOption);
  Vue.component('QueryPriceOption',QueryPriceOption);
  Vue.component('OrderItemDetail',OrderItemDetail);
  Vue.component('ItemDetail',ItemDetail);
  Vue.component('orderItemTag',orderItemTag);
  Vue.component('orderConditionTag',orderConditionTag);
  Vue.component('orderFunctionTag',orderFunctionTag);
  Vue.component('orderTag',orderTag);
  Vue.component('VoucherItem',VoucherItem);
  Vue.component('AprItem',AprItem);
  Vue.component('PriceRuleItem',PriceRuleItem);
}